import {environment} from "../../environments/environment";

export class API {

  static url(method: string): string {
    return `${environment.api_uri}/api/${method}`;
  }

}
